import defaultSource from "./defaultSource";

export default (function sourceRandomExponential(source) {
  function randomExponential(lambda) {
    return function() {
      return -Math.log(1 - source()) / lambda;
    };
  }

  randomExponential.source = sourceRandomExponential;

  return randomExponential;
})(defaultSource);



//////////////////
// WEBPACK FOOTER
// ./~/d3-random/src/exponential.js
// module id = 1355
// module chunks = 0